import { makeAutoObservable } from 'mobx'

interface IUser {
	isAuthenticated: boolean
	data: {
		AVN20: number
		AVN_BT_report: number
		doljnost: number
		id: number
		name: string
	}
	isLoading: boolean
}

class Auth {
	menuShow: boolean = false
	user: IUser = {
		isAuthenticated: false,
		data: {
			AVN20: 0,
			AVN_BT_report: 0,
			doljnost: 0,
			id: 0,
			name: ''
		},
		isLoading: false
	}

	constructor() {
		makeAutoObservable(this)
	}

	newUser(param: IUser) {
		this.user = param
	}

	setMenuShow(param: boolean) {
		this.menuShow = param
	}
}

export const auth = new Auth()
